module.exports = __webpack_public_path__ + "img/testpaper_eye_close.eee494e1.svg";